import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import React from 'react';
import { CloseButton, Button, Col, Form, Row, Spinner, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationListStandalone, PaginationProvider } from 'react-bootstrap-table2-paginator';
import { Link } from "react-router-dom";
import '../../App.css';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import ReactGA from "react-ga4";
import CurrencyInput from 'react-currency-input-field';
import cellEditFactory from 'react-bootstrap-table2-editor';

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
     return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
function creditCurrencyFormat(num) {
    return '$' + (-1 * num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
class ApplyCredits extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        console.log(props.location.state);

        this.state = {
            user: userExists ? props.location.state.user : {},
            account: props.location.state.account,
            page: 1,
            credits: props.location.state.credits,
            creditTotal: props.location.state.creditTotal,
            data: [],
            filteredData: [],
            totalSize: 0,
            sizePerPage: 10,
            selected: [],
            selectedIds: [],
            selectedTotal: 0,
            applyInvoices:[],
            searchTerm: '',
            filterEntityType: props.location.state.entityType,
            loading: false,
            creditLoading: false,
            emptyText: props.location.state.entityType == 'Boland' ? 'No open Boland invoices.' : 'No open Parklawn invoices.',
            emptyCreditText: 'No open credits.',
            applySummaryRows: [
                { 'BalanceDue': 'Selected Credit Amount:', 'ApplyAmount': props.location.state.creditTotal },
                { 'BalanceDue': 'Applied Credit Amount:', 'ApplyAmount': 0.00 },
                { 'BalanceDue': 'Remaining Invoice Balance:', 'ApplyAmount': 0.00 }],
            showModal: false,
            showLeftoverCreditModal: false,
            modalSelection: "3"
        };

        this.customSort = this.customSort.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.showButton = this.showButton.bind(this);
        this.handleApplyAmountChange = this.handleApplyAmountChange.bind(this);
        this.handleApplyTableChange = this.handleTableChange.bind(this);
        this.handleApplyCreditsSubmit = this.handleApplyCreditsSubmit.bind(this);

        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

        this.onHide = this.onHide.bind(this);
        this.onLCHide = this.onLCHide.bind(this);
        this.handleModalChange = this.handleModalChange.bind(this);
        this.submitRequest = this.submitRequest.bind(this);


        this.tableRef = React.createRef();
        this.creditTableRef = React.createRef();
        this.summaryTableRef = React.createRef();
        this.filterText = React.createRef();
    }

    componentDidMount() {
        this.handleTableChange("None", this.state);
    }

    handleFilterChange(event) {
        this.setState({
            filterEntityType: event.target.value,
            emptyText: 'No open ' + event.target.value + ' invoices.'
        }, () => {
            this.handleTableChange("None", this.state);
        });
    }
    handleClear(event) {
        event.preventDefault();
        this.filterText.current.value = '';
        this.setState({
            searchTerm: '',
            selected: [],
            selectedIds: [],
            page: 1,
            applySummaryRows: [
                { 'BalanceDue': 'Selected Credit Amount:', 'ApplyAmount': this.state.creditTotal },
                { 'BalanceDue': 'Applied Credit Amount:', 'ApplyAmount': 0.00 },
                { 'BalanceDue': 'Remaining Invoice Balance:', 'ApplyAmount': 0.00 }],
        }, function () {
            this.handleTableChange("None", { page: 1, sizePerPage: 10 });
        });
    }

    handleClearSearch(event) {
        event.preventDefault();
        console.log('here');
        this.filterText.current.value = '';
        this.setState({
            searchTerm: '',
            filteredData: this.state.data.sort(this.customSort)
        });
    }

    handleSearch(event) {
        event.preventDefault();
        this.state.page = 1;
        this.handleTableChange("None", this.state);
    }

    handleSearchChange(event) {
        let invoiceNumbers = this.state.selected.map(function (item) {
            return item['DocumentNumber'];
        });

        let xyz = this.state.data.filter(function (row) {
            if (row['PONumber'].toLowerCase().includes(event.target.value.toLowerCase())) return true;
            if (row['DocumentNumber'].toLowerCase().includes(event.target.value.toLowerCase())) return true;
            if (row['BuildingName'] != null && row['BuildingName'].toLowerCase().includes(event.target.value.toLowerCase())) return true;
            if (invoiceNumbers.includes(row['DocumentNumber'])) return true;
            return false;
        }).map(function (obj) {
            obj['isSelected'] = invoiceNumbers.includes(obj['DocumentNumber']);
            return obj;
        });

        this.setState({
            searchTerm: event.target.value,
            filteredData: xyz.sort(this.customSort)
        });
    }

    customSort(objA, objB) {
        if (moment(objA['DocumentDate']) > moment(objB['DocumentDate'])) {
            return 1;
        }
        else if (moment(objA['DocumentDate']) < moment(objB['DocumentDate'])) {
            return -1;
        }
        return 0;
    }

    handleSelect = (row, isSelect) => {
        let allow = true;
        let selected = [];
        let data = this.state.data;
        let rowIndex = this.state.data.findIndex(x => x.InvoiceKey == row.InvoiceKey);
        let applySummaryRows = this.state.applySummaryRows;
        let selectedCreditAmount = applySummaryRows[0].ApplyAmount;
        let appliedCreditAmount = applySummaryRows[1].ApplyAmount;
        let remainingInvoiceAmount = applySummaryRows[2].ApplyAmount;
        let remainingCreditAmount = selectedCreditAmount - appliedCreditAmount;
        console.log(typeof appliedCreditAmount);
        console.log(appliedCreditAmount);
        console.log(typeof selectedCreditAmount);
        console.log(selectedCreditAmount);
        if (isSelect) {
            if (this.state.selected.length >= 25) {
                selected = this.state.selected;
                alert('Maximum selected invoices reached (25).');
                allow = false;
            }
            else if (appliedCreditAmount >= selectedCreditAmount) {
                selected = this.state.selected;
                alert('Selected credits already fully applied');
            }
            else {
                selected = [...this.state.selected, row];
                if (remainingCreditAmount >= row.BalanceDue) {
                    row.ApplyAmount = Number(row.BalanceDue.toFixed(2));
                    appliedCreditAmount += row.BalanceDue;
                }
                else {
                    row.ApplyAmount = Number(remainingCreditAmount.toFixed(2));
                    appliedCreditAmount = selectedCreditAmount;
                    let remainingCalc = 0;
                    for (var i in selected) {
                        remainingCalc += (Number(selected[i].BalanceDue) - Number(selected[i].ApplyAmount));
                    }
                    remainingInvoiceAmount = remainingCalc;
                    remainingCreditAmount = 0;
                }

                data[rowIndex] = row;

                applySummaryRows[1].ApplyAmount = Number(appliedCreditAmount.toFixed(2));
                applySummaryRows[2].ApplyAmount = Number(remainingInvoiceAmount.toFixed(2));
            }
        }
        else {
            appliedCreditAmount -= row.ApplyAmount;
            row.ApplyAmount = 0.00;
            data[rowIndex] = row;
            selected = this.state.selected.filter(x => x.InvoiceKey !== row.InvoiceKey);
            let remainingCalc = 0;
            for (var i in selected) {
                remainingCalc += (Number(selected[i].BalanceDue) - Number(selected[i].ApplyAmount));
            }
            applySummaryRows[1].ApplyAmount = Number(appliedCreditAmount.toFixed(2));
            applySummaryRows[2].ApplyAmount = Number(remainingCalc);
            allow = false;
        }

        let invoiceNumbers = selected.map(function (item) {
            return item['DocumentNumber'];
        });

        let xyz = this.state.data.filter(function (row) {
            if (row['PONumber'].toLowerCase().includes(this.state.searchTerm.toLowerCase())) return true;
            if (row['DocumentNumber'].toLowerCase().includes(this.state.searchTerm.toLowerCase())) return true;
            if (invoiceNumbers.includes(row['DocumentNumber'])) return true;
            return false;
        }, this).map(function (obj) {
            obj['isSelected'] = invoiceNumbers.includes(obj['DocumentNumber']);
            return obj;
        });

        this.setState(() => ({
            applySummaryRows: applySummaryRows,
            selected: selected,
            data:data,
            selectedIds: selected.map(r => r.InvoiceKey),
            selectedTotal: selected.map(item => item.BalanceDue).reduce((prev, curr) => prev + curr, 0),
            filteredData: xyz.sort(this.customSort)
        }));
    }

    handleSelectAll = (isSelect, rows) => {
        if (isSelect) {
            let selectedRows = rows.slice(0, 25);
            this.setState(() => ({
                selected: selectedRows,
                selectedTotal: selectedRows.map(item => item.BalanceDue).reduce((prev, curr) => prev + curr, 0),
                selectedIds: selectedRows.map(r => r.InvoiceKey)
            }));
            if (selectedRows.length == 25) {
                alert('Maximum selected invoices reached (25).');
            }
            return selectedRows.map(r => r.InvoiceKey);
        } else {
            this.setState(() => ({
                selected: [],
                selectedIds: [],
                selectedTotal: 0,
                filteredData: this.state.data
            }));
            return [];
        }
    }

    handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        console.log(this.state);
        if (type == "pagination") {
            this.tableRef.current.selectionContext.selected = [];
            this.setState(() => ({
                selected: []
            }));
        }
        axios.get(`${Constants.apiURL}/api/Payment/invoices`, {
            params: {
                user: this.state.user.username,
                accountID: this.state.account.accountID,
                page: page,
                pageSize: sizePerPage,
                sortOrder: sortOrder,
                sortField: sortField,
                searchTerm: '',// this.state.searchTerm,
                type: this.state.filterEntityType,
                noPending:true
            }
        }).then(response => {
            console.log(response);
            if (response.data) {

                //state.bdata = JSON.parse(response.data.data);
                //state.btotalSize = response.data.rowcount;
                this.setState(() => ({
                    page: page,
                    sizePerPage: sizePerPage,
                    sortField: sortField,
                    sortOrder: sortOrder,
                    data: JSON.parse(response.data.data),
                    filteredData: JSON.parse(response.data.data),
                    totalSize: response.data.rowcount,
                    selected: []
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleApplyTableChange(type, { page, sizePerPage, sortField, sortOrder }) {

        console.log(type);
    }

    

    showButton() {
        if (this.state.loading) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleDownloadSelected}>
                Download Selected
            </Button>
        }
    }
    handleApplyAmountChange = (oldValue, newValue, row) => {
        console.log(oldValue);
        console.log(newValue);
        console.log(this.state.selected.find((item) => item.InvoiceKey === row.InvoiceKey));

        let applySummaryRows = this.state.applySummaryRows;
        let selectedCreditAmount = applySummaryRows[0].ApplyAmount;
        let appliedCreditAmount = 0.00;
        let remainingInvoiceAmount = 0.00;

        for (var i in this.state.selected) {
            console.log(this.state.selected[i]);
            appliedCreditAmount += Number(this.state.selected[i].ApplyAmount);
            remainingInvoiceAmount += (Number(this.state.selected[i].BalanceDue) - Number(this.state.selected[i].ApplyAmount));
        }

        applySummaryRows[1].ApplyAmount = Number(appliedCreditAmount.toFixed(2));
        applySummaryRows[2].ApplyAmount = Number(remainingInvoiceAmount.toFixed(2));

        this.setState({ applySummaryRows });

        if (applySummaryRows[1].ApplyAmount > applySummaryRows[0].ApplyAmount) {
            alert('Requested credit amount exceeds sum of selected credits. Please select fewer invoices or reduce requested credit amount(s).');
        }
    }
    handleApplyCreditsSubmit() {
        let applySummaryRows = this.state.applySummaryRows;
        let selectedCreditAmount = applySummaryRows[0].ApplyAmount;
        let appliedCreditAmount = applySummaryRows[1].ApplyAmount;
        let remainingInvoiceAmount = applySummaryRows[2].ApplyAmount;
        if (selectedCreditAmount < appliedCreditAmount) {
            alert('Requested credit amount exceeds sum of selected credits. Please select fewer invoices or reduce requested credit amount(s).');
            return;
        }
        if (remainingInvoiceAmount > 0) {
            this.setState({ showModal: true });
            return;
        }
        if (selectedCreditAmount > appliedCreditAmount && this.state.data.length > this.state.selected.length) {
            this.setState({ showLCModal: true });
            return;
        }
        this.submitRequest();
    }

    onHide() {
        this.setState({ showModal: false });
    }
    onLCHide() {
        this.setState({ showLCModal: false });
    }

    handleModalChange(event) {
        console.log(event.target);
        this.setState({
            modalSelection: event.target.value
        });
    }

    submitRequest() {
        this.setState({
            showModal: false,
            showLCModal: false
        });

        let creditNums = this.state.credits.reduce(function (tot, val) { return tot + ", " + val.PaymentNumber }, "").trim().replace(/^,+/, '').replace(/,+$/, '');

        let invoices = JSON.stringify(this.state.selected.map(x => ({
            InvoiceKey: x.InvoiceKey,
            DocumentNumber: x.DocumentNumber,
            BalanceDue: x.BalanceDue,
            ApplyAmount: x.ApplyAmount
        })));


        axios.get(`${Constants.apiURL}/api/Request/ApplyCredit`, {
            params: {
                user: this.state.user.username,
                accountID: this.state.account.accountID,
                accountName: this.state.account.accountName,
                creditTotal: this.state.creditTotal,
                creditString: creditNums,
                invoiceJSON: invoices,
                remainingBalance: this.state.applySummaryRows[2].ApplyAmount,
                paymentOption: this.state.modalSelection
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                alert('Your credit request has been received, and should be processed within one (1) business day. You will receive a confirmation email for this request shortly, and we will reach out once complete.');
                this.props.history.push({
                    pathname: '/open_invoices',
                    state: {
                        user: this.state.user,
                        account: this.state.account
                    }
                });
            }
            else {
                alert('Error processing your request. If this issue persists please contact us at AR@boland.com.');
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            alert('Failed to contact server');
            console.log('request failed', response)
        });



    }

    render() {
        const { filteredData, emptyText, selectedIds, filteredCreditData, selectedCreditIds, emptyCreditText, selected, showModal, showLCModal } = this.state;
        const columns = [
            {
                dataField: 'DocumentNumber',
                text: 'Invoice #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'PONumber',
                text: 'PO #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DocumentDate',
                text: 'Invoice Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DueDate',
                text: 'Due Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OriginalAmount',
                text: 'Total Invoice Amount',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceDue',
                text: 'Invoice Balance',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'InvoiceStatus',
                text: 'Status',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BuildingName',
                text: 'Building',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            }

        ];
        const appliedInvoiceColumns = [
            {
                dataField: 'DocumentNumber',
                text: 'Invoice Number',
                align: 'center',
                editable: false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceDue',
                text: 'Invoice Balance',
                editable: false,
                align: (cell, row) => {
                    if (typeof cell == "number") return 'center';
                    else return "right";
                },
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: (cell, row) => {
                    console.log(cell);
                    console.log(row);
                    console.log(this.state.applySummaryRows[0].ApplyAmount);
                    if (typeof cell == "number") {
                        return '$' + cell.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    }
                    else if (cell == "Selected Credit Amount:") {
                        return <Form.Label style={{ fontWeight: 'bold', color: 'green', fontSize: '18px' }}> {cell} </Form.Label>;
                    }
                    else if (cell == "Applied Credit Amount:" && this.state.applySummaryRows[0].ApplyAmount < Number(row.ApplyAmount)) {
                        return <Form.Label style={{ fontWeight: 'bold', color: 'red', fontSize: '18px' }}> {cell} </Form.Label>;
                    }
                    else return <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}> {cell} </Form.Label>;
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'ApplyAmount',
                text: 'Requested Credit Amount',
                align: '-webkit-right',
                editable: (content, row, rowIndex, columnIndex) => { return typeof row.BalanceDue == "number"},
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                validator: (newValue, row, column) => {
                    if (!String(newValue).match(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/)) {
                        return {
                            valid: false,
                            message: 'Invalid number'
                        };
                    }
                    if (Number(newValue) > row.BalanceDue) {
                        return {
                            valid: false,
                            message: 'Cannot apply more than invoice balance.'
                        };
                    }

                    return true;
                },
                editCellStyle: (cell, row, rowIndex, colIndex) => {
                    const backgroundColor = cell > 2101 ? '#00BFFF' : '#00FFFF';
                    return { width:'100px' };
                },
                formatter: (cell, row) => {
                    if (typeof row.BalanceDue == "number") {
                        return <div class="input-group" style={{ width: '140px' }}>
                            <div class="input-group-prepend">
                                <span class="input-group-text">$</span>
                            </div>
                            <Form.Control style={{ textAlign: '-webkit-right', width: '100px' }} value={Number(cell).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} type="input" size="sm" />
                        </div>
                    }
                    else if (row.BalanceDue == "Selected Credit Amount:") {
                        return <Form.Label style={{ fontWeight: 'bold', color: 'green', justifySelf: 'right' }}>${cell.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</Form.Label>;
                    }
                    else if (row.BalanceDue == "Applied Credit Amount:" && this.state.applySummaryRows[0].ApplyAmount < cell) {
                        return <Form.Label style={{ fontWeight: 'bold', justifySelf: 'right', color:'red' }}>${cell.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</Form.Label>;
                    }
                    else {
                        return <Form.Label style={{ fontWeight: 'bold', justifySelf: 'right' }}>${cell.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</Form.Label>;
                    }
                },
                style: {
                    verticalAlign: 'middle'
                }
            }
        ];
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            hideSelectAll: true,
            selected: selectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };

        const selectRowSummary = {
            mode: 'checkbox',
            onSelect: this.handleSelect,
            hideSelectAll: true,
            selected: selectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };
        return (
            <div class="open_invoices">
                <Modal show={showModal} onHide={this.onHide}>
                    <Modal.Header style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }} closeButton >
                        <Modal.Title>Payment Options</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Form.Label>Would you like to request a payment on the remaining invoice balance of <b>${Number(this.state.applySummaryRows[2].ApplyAmount).toFixed(2)}</b>?</Form.Label>
                            <Form.Check value="3" label="Yes, I would like to pay on the portal. Please contact me when the credit request has been processed." name="modalSelection" type='radio' checked={this.state.modalSelection === "3"} onChange={this.handleModalChange} />
                            <Form.Check value="1" label="Yes, please send me a one-time payment link." name="modalSelection" type='radio' checked={this.state.modalSelection === "1"} onChange={this.handleModalChange}/>
                            <Form.Check value="2" label="Yes, please call me for payment information." name="modalSelection" type='radio' checked={this.state.modalSelection === "2"} onChange={this.handleModalChange} />
                            <Form.Check value="4" label="No, not at this time. I will pay the balance later." name="modalSelection" type='radio' checked={this.state.modalSelection === "4"} onChange={this.handleModalChange} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'flex-start' }}>
                        <Button variant="primary" name="confirm" onClick={this.submitRequest} style={{ backgroundColor: '#1F419B' }}>
                            Submit
                        </Button>
                        <Button variant="secondary" name="cancel" onClick={this.onHide}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showLCModal} onHide={this.onLCHide}>
                    <Modal.Header style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }} closeButton >
                        <Modal.Title>Remaining Credit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Form.Label>There is a remaining credit balance of <b>${Number(this.state.applySummaryRows[0].ApplyAmount - this.state.applySummaryRows[1].ApplyAmount).toFixed(2)}</b>. Would you like to select additional invoice(s) to apply this amount towards?</Form.Label>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'flex-start' }}>
                        <Button variant="primary" name="confirm" onClick={this.onLCHide} style={{ backgroundColor: '#1F419B' }}>
                            Yes, return to selection
                        </Button>
                        <Button variant="secondary" name="cancel" onClick={this.submitRequest}>
                            No, submit current selection
                        </Button>
                    </Modal.Footer>
                </Modal>
                <SiteMenu user={this.state.user} currentPage='openInvoices' />
                <Form className="mb-3" onSubmit={e => { e.preventDefault(); }}>
                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 15px 0px 10px' }}>

                        <Col md={{ span: 'auto', order: 0 }} xs={{ span: 'auto', order: 0 }}>
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>APPLY CREDITS: INVOICE SELECTION</Form.Label>
                        </Col>
                        <Col md={{ span: '100%', order: 1}} className="filler-col"/>
                        <Col md={{ span: 'auto', order: 2 }} xs={{ span: 'auto', order: 2 }} className="mobile-p-t-10" style={{ paddingRight: 0 }}>
                            <Row style={{paddingRight:'15px'}}>
                                <Form.Label style={{ marginBottom: 0, paddingBottom: 3, verticalAlign: 'middle', width:'auto' }}>Company Name:</Form.Label>
                                <Form.Select disabled={true} size="sm" name="filterType" style={{ width: "200px" }} value={this.state.filterEntityType}>
                                    <option value="Boland">Boland</option>
                                    <option value="Parklawn">Parklawn</option>
                                </Form.Select>
                            </Row>
                        </Col>
                        <Col md={{ span: 'auto', order: 3 }} xs={{ span: 'auto', order: 3 }} className="mobile-p-t-10" >
                            <div class="form-group position-relative">
                                <Form.Control ref={this.filterText} value={this.state.searchTerm} type="input" size="sm" onChange={this.handleSearchChange} placeholder="Search by invoice, PO number, or building..." style={{ width: "320px" }} />
                                <span class="form-clear">
                                    <CloseButton size="sm" style={{ backgroundColor: 'white', border: 0, height: '0.2em', width: '0.2em' }}
                                        onClick={this.handleClearSearch} />
                                </span>
                            </div>
                        </Col>
                        <Col md={{ span: 'auto', order: 4 }} xs={{ span: 'auto', order: 4 }} >
                            <Button size="sm" style={{ width: 'auto', marginLeft: 0 }} variant="secondary" onClick={this.handleClear}>Clear</Button>
                        </Col>
                        <Col md={{ span: 'auto', order: 5 }} xs={{ span: 'auto', order: 1 }}>
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.account.accountID} | {this.state.account.accountName}</Form.Label>
                        </Col>
                    </Form.Group>
                    <Row>
                        <Form.Label style={{ marginLeft: '10px', marginTop: '5px', marginBottom: '0px', verticalAlign: 'middle', fontStyle: 'italic' }}>The sum of selected credits is listed in green below. Please check the invoice(s) below to which you'd like to apply this amount.</Form.Label>
                    </Row>
                </Form>
                <div>
                    <BootstrapTable
                        remote
                        id="open_invoices_table"
                        keyField="InvoiceKey"
                        wrapperClasses="table-responsive open_invoices_table_credit"
                        data={filteredData}
                        columns={columns}
                        onTableChange={this.handleTableChange}
                        selectRow={selectRow}
                        noDataIndication={() => <Form.Label>{emptyText}</Form.Label>}
                        striped
                        hover
                        ref={this.tableRef}
                    />
                </div>
                <BootstrapTable
                    id="open_invoices_table"
                    keyField="InvoiceKey"
                    wrapperClasses="table-responsive open_invoices_table_credit_apply"
                    data={selected}
                    columns={appliedInvoiceColumns}
                    onTableChange={this.handleApplyTableChange}
                    hover
                    ref={this.creditTableRef}
                    selectRow={selectRowSummary}
                    noDataIndication={() => <Form.Label>No invoices selected.</Form.Label>}
                    cellEdit={cellEditFactory({
                        mode: 'click',
                        blurToSave: true,
                        afterSaveCell: (oldValue, newValue, row, column) => { this.handleApplyAmountChange(oldValue, newValue, row); }
                    })}
                />
                <div style={{ maxWidth: '800px' }} className="mobile-m-r-20">
                    <Row style={{ textAlign: '-webkit-right' }}>
                        <Col>
                            <Form.Label
                                className={this.state.applySummaryRows[1].ApplyAmount == this.state.applySummaryRows[0].ApplyAmount ? 'green-text' : this.state.applySummaryRows[1].ApplyAmount > this.state.applySummaryRows[0].ApplyAmount ? 'red-text' : 'black-text'}
                                style={{ fontWeight: 'bold', fontSize: '18px', paddingTop: '5px' }}>Total: </Form.Label>
                        </Col>
                        <Col style={{ maxWidth: '150px', paddingRight: '0px' }}>
                            <Form.Control
                                className={this.state.applySummaryRows[1].ApplyAmount == this.state.applySummaryRows[0].ApplyAmount ? 'green-text' : this.state.applySummaryRows[1].ApplyAmount > this.state.applySummaryRows[0].ApplyAmount ? 'red-text' : 'black-text'}
                                style={{ maxWidth: '150px', textAlign: 'end', fontWeight: 'bold', fontSize: '18px' }} type="text" disabled name="selectedAmount" value={"$" + this.state.applySummaryRows[1].ApplyAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} />
                        </Col>
                    </Row>
                    <Row style={{textAlign:'-webkit-right'}}>
                        <Col>
                            <Form.Label style={{ fontWeight: 'bold', color: 'green', fontSize: '18px', paddingTop:'5px' }}>Selected Credit Sum: </Form.Label>
                        </Col>
                        <Col style={{maxWidth:'150px', paddingRight:'0px'}}>
                            <Form.Control style={{ maxWidth: '150px', textAlign: 'end', fontWeight: 'bold', color: 'green', fontSize: '18px'}} type="text" disabled name="selectedAmount" value={"$"+this.state.applySummaryRows[0].ApplyAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}/>
                        </Col>
                    </Row>
                    <Row style={{ textAlign: '-webkit-right' }}>
                        <Col>
                            <Form.Label style={{ fontWeight: 'bold', fontSize: '18px', paddingTop: '5px' }}>Selected Invoice Balance: </Form.Label>
                        </Col>
                        <Col style={{ maxWidth: '150px', paddingRight: '0px' }}>
                            <Form.Control style={{ maxWidth: '150px', textAlign: 'end', fontWeight: 'bold', fontSize: '18px', }} type="text" disabled name="selectedAmount" value={"$" + this.state.applySummaryRows[2].ApplyAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} />
                        </Col>
                    </Row>
                    <Row style={{ textAlign: '-webkit-right' }}>
                        <Col style={{paddingRight:'0px'}}>
                        <Button style={{ backgroundColor: '#00973A', margin: '5px', marginRight:'0px', width:'auto' }} variant="primary" type="submit" onClick={this.handleApplyCreditsSubmit}>
                            Submit Request
                        </Button>
                        </Col>
                    </Row>
                </div>
            </div >
        );
    }
}

export default ApplyCredits;